module.exports = __webpack_public_path__ + "static/img/daijiejue.ba21f759.png";